import base from "../baseurl";
import token from "../getTk";

const Show = async () => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const status = await api
    .post("good-delivery-types/showall", {
      json: {},
    })
    .json();
  //console.log("Llego al fetch", status);
  return status;
};

export default Show;
